/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const DomainsTabSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      {Array.from({ length: 9 }).map((_, i) => {
        return (
          <React.Fragment key={i}>
            <div className={classes.firstPart}>
              <div className={classes.column}>
                <div className={classes.firstRow}>
                  <Skeleton count={1} width={90} className={classes.shortSk} />
                  <Skeleton count={1} width={90} className={classes.shortSk} />
                </div>
                <div>
                  <Skeleton count={1} width={190} className={classes.shortSk} />
                </div>
              </div>
              <div className={classes.secondRow}>
                <Skeleton count={1} width={10} className={classes.shortSk} />
              </div>
            </div>
            <div className={classes.dividerContainer}>
              <hr className={classes.border} />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DomainsTabSkeleton;
